'use client';
import React, { useContext, useEffect, useState } from 'react';
import AppMessage from '@/components/general/AppMessage';
import Toolbar from '@/components/structure/Toolbar';
import { usePathname } from 'next/navigation';
import { useRouter } from 'next/navigation';
import styles from './page.module.css';
import findLocale from '@/functions/findLocale';
import { LayoutContext, useLayoutContext } from '@/context/LayoutContext';
// import ModalsContainer from '@/components/Modals/ModalsContainer';
// import Footer from '@/components/structure/Footer';
import config from '@/api/global';
import CookieFunction from '@/functions/cookieFunction';
import Api from '@/api';
import Footer from '@/components/structure/Footer';
import Modal from '@/components/structure/Modal';
import ModalsContainer from '@/components/Modals/ModalsContainer';
import { normalizeApiError } from '@/functions/normalizeApiError';

const UiLayout = ({ children, locale }: { children: React.ReactNode; locale?: string }) => {
  const {
    serverMessage,
    reRender,
    setRerender,
    login,
    showOverflow,
    setShowOverflow,
    visible,
    setVisible,
    trigger,
    singleItem,
    logoutFunction,
    getCartList,
    footerSubCategory,
  } = useLayoutContext();

  const [collapsed, setCollapsed] = useState(false);
  const [template, setTemplate] = useState('default');
  const pathname = usePathname();
  const router = useRouter();

  const chatTemplate = ['chat', 'dashboard'];
  const signTemplate = ['login', 'signup', 'forget-password', 'sub-user'];

  useEffect(() => {
    setVisible(true);
  }, [router]);

  useEffect(() => {
    const handleRouteChange = () => {
      console.log('🔙 Browser back or navigation triggered!');
    };
    window.addEventListener('popstate', handleRouteChange);

    return () => {
      window.removeEventListener('popstate', handleRouteChange);
    };
  }, [pathname]);

  useEffect(() => {
    const matched_chat = chatTemplate.some((item) => pathname?.includes(item));
    const matched_sign = signTemplate.some((item) => pathname?.includes(item));
    if (matched_chat) {
      setTemplate('chat');
    } else if (matched_sign) {
      setTemplate('sign');
    } else {
      setTemplate('default');
    }
  }, [pathname]);
  const toggleMenuFunction = () => {
    setCollapsed(!collapsed);
  };

  useEffect(() => {
    if (typeof window !== 'undefined' && typeof document !== 'undefined') {
      config.udata = CookieFunction('get', config.tokenName);
      console.log('token==', CookieFunction('get', config.tokenName), config.udata);
      let isLogin = CookieFunction('get', config.tokenName);
      console.log('isLogin==', isLogin);
      if (isLogin) {
        Api.checkLogin()
          .then((res) => {
            console.log('res==', res);
            if (res.data.response.status == 403 && isLogin) {
              logoutFunction();
              window.location.reload();
            }
          })
          .catch((err) => {
            console.log('checklogin========', err);
            const { code, status } = normalizeApiError(err);
            const shouldLogout =
              code === 'UNAUTHENTICATED' ||
              code === 'INVALID_TOKEN' ||
              code === 'TOKEN_EXPIRED' ||
              status === 401 ||
              status === 403;
            if (shouldLogout && isLogin) {
              logoutFunction();
              window.location.reload();
            }
          });
      }
    }
  }, []);
  // useEffect(() => {
  //   // let element = document.documentElement;
  //   if (template == 'chat') {
  //     document.documentElement.style.overflow = 'hidden';
  //   }
  // }, [template]);
  // useEffect(() => {
  //   if (document) {
  //     let element = document.getElementById('pageContent');
  //     if (element) {
  //       if (!showOverflow) {
  //         element.style.overflow = 'hidden';
  //       } else {
  //         element.style.overflowY = 'auto';
  //       }
  //     }
  //   }
  // }, [showOverflow]);

  useEffect(() => {
    if (template != 'chat') {
      if (trigger || singleItem != undefined) {
        document.documentElement.style.overflow = 'hidden';
      } else {
        document.documentElement.style.overflowY = 'auto';
      }
    }
  }, [trigger]);
  console.log('triggeris', trigger, singleItem);

  console.log('singleItem==', singleItem);
  console.log('pathname==', login, pathname, '' + findLocale(), pathname, `${findLocale()}`);
  console.log('footerSubCategory==', footerSubCategory);
  return (
    <div className={`${visible ? 'fade-in' : 'fade-out'} uilayoutWrapper`}>
      <AppMessage
        Message={serverMessage?.text}
        backgroundColor={serverMessage?.backgroundColor}
        type={serverMessage?.type}
      />
      {template == 'default' && (
        <div>
          <Toolbar locale={locale} />
        </div>
      )}
      {/* <div
        className={`${styles.pageContent} ${template == 'chat' && styles.chatPageContent} ${template == 'sign' && styles.signPageContent}`}
        id="pageContent"
      > */}
      <div
        className={`${styles.pageContent} ${pathname?.includes('blog') && styles.hiddenOverflow} `}
        id="pageContent"
      >
        {children}
      </div>

      <ModalsContainer />
      {/* {template == 'default' && <Footer />} */}
      {template == 'default' && <Footer footerSubCategory={footerSubCategory} />}

      {/* <NavigationMobile
          toggleMenuFunction={toggleMenuFunction}
          locale={locale}
          setCollapsed={setCollapsed}
        /> */}
      {/* </div> */}
    </div>
  );
};
export default UiLayout;
